import api from 'api/instance';
import { ActivityType } from 'types/activity';

const URL = `${process.env.REACT_APP_GOOD_MOVE_BASE_DOMAIN}/v1/activity/types`;

export const getActivityTypes = async (): Promise<ActivityType[]> => {
  const { data } = await api.get<ActivityType[]>(URL);
  return data;
};
